/**
 * Статусы записи клиента: подписи для UI и признак «предстоящая неоплаченная».
 * Сырые коды статусов (`pending_payment` и т.п.) пользователю не показываются.
 */

type BookingTimeFields = {
  slot_date: string;
  start_time?: string | null;
  end_time?: string | null;
};

type BookingPaymentFields = BookingTimeFields & {
  status: string;
  service_payment_required: boolean;
  payment_received: boolean;
};

const BOOKING_STATUS_LABELS: Record<string, string> = {
  pending: 'Ожидает',
  pending_payment: 'Ожидает оплаты',
  cash_waiting: 'Оплата в студии',
  confirmed: 'Подтверждено',
  cancelled: 'Отменено',
  completed: 'Завершено',
  no_show: 'Не явился'
};

/** Подпись статуса записи; неизвестный код не выводится как есть. */
export function bookingStatusLabel(status: string): string {
  return BOOKING_STATUS_LABELS[status] ?? 'Статус уточняется';
}

export function bookingStatusBadgeClass(status: string): string {
  if (status === 'confirmed') return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200';
  if (status === 'pending' || status === 'pending_payment' || status === 'cash_waiting') {
    return 'bg-[var(--warn-bg)] text-[var(--warn-text)]';
  }
  if (status === 'no_show') return 'bg-[var(--error-bg)] text-[var(--error-text)]';
  return 'bg-[var(--bg-soft)] text-[var(--text-muted)]';
}

/** Момент окончания занятия (локальное время устройства), мс. */
export function bookingEndTs(b: BookingTimeFields): number {
  const t = (b.end_time || b.start_time || '23:59').slice(0, 5);
  return new Date(`${b.slot_date}T${t}:00`).getTime();
}

/** Неоплаченная запись, занятие по которой ещё не закончилось (для счётчика на «Мои записи»). */
export function isUpcomingUnpaidBooking(b: BookingPaymentFields, nowMs: number): boolean {
  if (b.status === 'cancelled') return false;
  if (!b.service_payment_required || b.payment_received) return false;
  const end = bookingEndTs(b);
  return Number.isFinite(end) && end > nowMs;
}
